export const cols_1= [
  {
    title: "生产单状态",
    key: "order_status",
    align: "center",
    width:'17vw'
  },
  {
    title: "计划单号",
    key: "order_no",
    align: "center"
  },

  {
    title: "今日完成情况",
    key: "today_situation",
    align: "center",
    slot: "today_situation",
    slot_head: "today_situationhead",
    
  }
  ]

  export const cols_2= [
    {
        title: "排名",
        width:"10vw",
        key: "ranking",
        align: "center",
        slot: "ranking"
      },
      {
        title: "图片",
        key: "img",
        align: "center",
        slot: "img"
      },
      {
        title: "货号",
        key: "goodsno",
        align: "center"
      },
      {
        title: "商品浏览量",
        key: "goods_browse",
        align: "center"
      },
      {
        title: "商品访客数",
        key: "goods_visitor",
        align: "center"
      },
      {
        title: "支付件数",
        key: "pay_number",
        align: "center"
      }
  ]